<template>
    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Add Vehicle" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="vehicleForm">
                <v-text-field color="primary" type="text" label="Name" id="name" name="name" v-model="newVehicle.name"
                    required :rules="nameRules"></v-text-field>
                <v-text-field color="primary" type="color" label="Mark color" id="boat_mark_color"
                    name="boat_mark_color" v-model="newVehicle.boat_mark_color" required
                    :rules="colorRules"></v-text-field>
                <v-text-field color="primary" type="color" label="Waypoint color" id="boat_waypoint_color"
                    name="boat_waypoint_color" v-model="newVehicle.boat_waypoint_color" required
                    :rules="colorRules"></v-text-field>
                <v-text-field color="primary" type="color" label="Route color" id="route_color" name="route_color"
                    v-model="newVehicle.route_color" required :rules="colorRules"></v-text-field>
                <v-text-field color="primary" label="MAC Address" v-model="newVehicle.mac" required :rules="macRules"
                    placeholder="0:0:0:0"></v-text-field>
                <DescriptiveInput v-model:descriptive-file="descriptiveFile"></DescriptiveInput>
                <v-select color="primary" label="Icon" :items="icons" item-title="name" item-value="name"
                    v-model="newVehicle.icon" required :rules="iconRules">
                    <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props">
                            <template v-slot:prepend>
                                <Icon :icon="item.raw.name" class="mr-4"></Icon>
                            </template>
                            {{ item.raw.name }}
                        </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                        <Icon v-if="item.raw.name" :icon="item.raw.name"></Icon>
                        {{ item.raw.name }}
                    </template>
                </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="validate()" class="w-100" color="primary" variant="elevated" text="Create vehicle"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { onMounted, ref } from 'vue';
import { nameRules, colorRules, macRules, descriptiveRules, iconRules, tooltipText } from './rules/vehicle';
import { useVehicleStore } from '@/store/vehicleStore';
import { icons } from '@/components/icons/icon';
import Icon from '@/components/icons/Icon.vue';
import DescriptiveInput from '../vehicles/DescriptiveInput.vue';

const vehicleStore = useVehicleStore();
const loading = ref(false);
const emit = defineEmits(['close'])

const newVehicle = ref({
    name: '',
    boat_mark_color: '#002885',
    boat_waypoint_color: '#002885',
    route_color: '#002885',
    mac: '',
    descriptive: {},
    icon: ''
});
const descriptiveFile = ref();
const vehicleForm = ref();


const validate = async () => {
    const isValid = await vehicleForm.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            const text = await descriptiveFile.value.text();
            newVehicle.value.descriptive = JSON.parse(text);
            await vehicleStore.createVehicle(newVehicle.value);
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación de la mision:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}

</script>
